import type { FC } from 'react'
import { ReminderCell } from '../../../../integrations/reminder'

export const RemindersRenderer: FC<{
  reminders: Array<any>
  isLast: boolean
  onReminderClick: (reminderId: string) => void
  view?: {
    name: string
    icons: Array<string>
  }
}> = ({ reminders, onReminderClick, view }) => {
  return (
    <div className="mb-1 mt-2 flex flex-col gap-2">
      {reminders.map((reminder: any) => (
        <ReminderCell key={reminder.id} reminder={reminder} view={view} onClick={onReminderClick} />
      ))}
    </div>
  )
}
